import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
} from '@cigna/chcp/shared/environment-util';

const digitaledgeChcp = 'https://p-chcp.digitaledge.cigna.com';
const digitaledgeGsg = 'https://p-gsg.digitaledge.cigna.com';

export const environment: EnvironmentConfig = {
  ...environmentDefaults('chcp-web'),
  authMethod: 'auth0',
  oidc: {
    clientId: '',
    redirectUri: '',
    metadataUri: '',
    authorizeUri: '',
    publicUris: [],
    noRefreshUris: [],
    secureUris: [],
  },
  auth0: {
    audience: digitaledgeChcp,
    clientId: 'xs3103SGaAN7xkz8vlGhBF6Si2rVUGa5',
    connection: 'providers-prod',
    domain: 'https://p.universal-login.cigna.com',
    scope: 'openid profile email',
    redirect_uri: 'https://cignaforhcp.cigna.com',
    secureUris: [digitaledgeChcp, digitaledgeGsg, '/prv/secure', '/pbc'],
    impersonationConnection: 'workforce',
    impersonationReturnTo: '/dashboard',
    cookieStorage: true,
  },
  redirect: {
    resourceLibrary: 'https://static.cigna.com/',
    resourceLibraryDrupal: 'https://cignamicrositesprod.prod.acquia-sites.com/',
    crossOrigin: {
      domain: 'https://provider.evernorth.com',
    },
    mhk: '/isam/sps/chcp-p-idp-mhk/saml20/logininitial?PartnerId=https://cignaportal.medhokapps.com/pportal',
    inbox:
      '/isam/sps/chcp-p-idp-proofpoint/saml20/logininitial?PartnerId=https://saml-entity-id.proofpoint.com/cigna_hosted-pe3',
    upx: {
      submit: 'https://mypa-cignaforhcp.cigna.com?state=new',
      modify: 'https://mypa-cignaforhcp.cigna.com?state=resume',
    },
    tableau: {
      url: 'https://cacforhcp.da-ccc-prod.aws.cignacloud.com',
    },
  },
  omni: {
    sonicNotification: 'https://static.cigna.com/spa/chcp/',
    identityUrl: `${digitaledgeChcp}/converse/identity`,
    botUrl: `${digitaledgeChcp}/converse/bot`,
    liveUrl: `${digitaledgeChcp}/converse/live/user`,
    publicUrl: `${digitaledgeChcp}/converse`,
  },

  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: '',
      resourceContent: 'https://p-digital-static.digitaledge.cigna.com/',
      secureApi: digitaledgeChcp,
      publicApi: `https://p-public.digitaledge.cigna.com/public`,
      gsgPublicApi: `${digitaledgeGsg}/public`,
      gsgSecureApi: digitaledgeGsg,
      graphql: `${digitaledgeChcp}/apollo-graphql`,
      privateLinkRouter: `https://p-chcp.digitaledge.cigna.com/pbc/identity/v1/federate/_route`,
      publicLinkRouter: '', // todo: update
    },
    searchIndex: 'prod',
    salesDemo: false,
  },
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhPower: false,
    hasCBHAmIInNetwork: false,
    cocePathwellPCLM: false,
  },
  launchDarklyClientId: '6627eacd49bac51024871748',
  disabledRoutes: [],
};
